export const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://toop.vip' : 'http://localhost:3000'
export const API_URL = process.env.NODE_ENV === 'production' ? 'https://toop.vip/api' : 'http://localhost:8000/api'
